import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

import { Field } from 'utils/types/shared/enums';
import { Block } from 'system/Stages/types';
import { toJS } from 'utils/helpers';
import {
  selectCorporateBlock,
  selectCorporateBlockStep,
  SubStore,
} from '../selectors';

export const makeSelectAccountActivity = () =>
  createSelector(
    selectCorporateBlock(Block.ACCOUNT_ACTIVITY),
    (state: Map<string, any>) => state.get('activity', Map()) || Map({})
  );

export const makeSelectPrimaryPurpose = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.PRIMARY_PURPOSE_CORPORATE, '')
  );

export const makeSelectPrimaryPurposeDetailed = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.PRIMARY_PURPOSE_DETAILED_CORPORATE, '')
  );

export const makeSelectPlannedMonthlyDepositVolumeUSD = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.PLANNED_MONTHLY_DEPOSIT_VOLUME_USD, '')
  );

export const makeSelectPlannedMonthlyWithdrawalVolumeUSD = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.PLANNED_MONTHLY_WITHDRAWAL_VOLUME_USD, '')
  );

export const makeSelectExpectedDepositOperationsMonthly = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.EXPECTED_DEPOSIT_OPERATIONS_MONTHLY, '')
  );

export const makeSelectExpectedDailyDepositVolume = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.EXPECTED_DAILY_DEPOSIT_VOLUME, '')
  );

export const makeSelectMaxDepositPerTransaction = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    state.get(Field.MAX_DEPOSIT_PER_TRANSACTION, '')
  );

export const makeSelectWithdrawalAccountCountries = () =>
  createSelector(makeSelectAccountActivity(), (state) =>
    toJS(state.get(Field.WITHDRAWAL_ACCOUNT_COUNTRIES, List())) || []
  );

export const makeSelectAccountActivityStepMeta = (stepId: string) =>
  createSelector(
    selectCorporateBlockStep(Block.ACCOUNT_ACTIVITY, SubStore.META, stepId),
    (value: any) => value
  );

export const makeSelectAccountActivityMeta = () =>
  createSelector(makeSelectAccountActivityStepMeta('activity'), (value: any) => value || Map({}));

export const makeSelectPrimaryPurposeMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.PRIMARY_PURPOSE_CORPORATE, Map())
  );

export const makeSelectPrimaryPurposeDetailedMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.PRIMARY_PURPOSE_DETAILED_CORPORATE, Map())
  );

export const makeSelectPlannedMonthlyDepositVolumeUSDMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.PLANNED_MONTHLY_DEPOSIT_VOLUME_USD, Map())
  );

export const makeSelectPlannedMonthlyWithdrawalVolumeUSDMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.PLANNED_MONTHLY_WITHDRAWAL_VOLUME_USD, Map())
  );

export const makeSelectExpectedDepositOperationsMonthlyMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.EXPECTED_DEPOSIT_OPERATIONS_MONTHLY, Map())
  );

export const makeSelectExpectedDailyDepositVolumeMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.EXPECTED_DAILY_DEPOSIT_VOLUME, Map())
  );

export const makeSelectMaxDepositPerTransactionMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.MAX_DEPOSIT_PER_TRANSACTION, Map())
  );

export const makeSelectWithdrawalAccountCountriesMeta = () =>
  createSelector(makeSelectAccountActivityMeta(), (state) =>
    state.get(Field.WITHDRAWAL_ACCOUNT_COUNTRIES, Map())
  );
